// import React from "react";

// export const formatFileType = (mimeType, fileName = "") => {
//   if (!mimeType) return "unknown";

//   const map = {
//     "application/pdf": "pdf",
//     "text/csv": "csv",
//     "application/vnd.ms-excel": "xls",
//     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
//     "application/msword": "doc",
//     "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
//     "text/plain": "txt",
//   };

//   // Check mapping
//   if (map[mimeType]) return map[mimeType];

//   // fallback → try extract extension from filename
//   const parts = fileName.split(".");
//   if (parts.length > 1) return parts.pop().toLowerCase();

//   return mimeType;
// };

export const formatFileType = (mimeType, fileName = "") => {
  if (!mimeType) return "Unknown";

  const lowerType = mimeType.toLowerCase();

  const map = {
    "application/pdf": "PDF",
    "text/csv": "CSV",
    "application/vnd.ms-excel": "XLS",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "XLSX",
    "application/msword": "DOC",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      "DOCX",
    "text/plain": "TXT",
    "text/html": "WEB",
    webpage: "WEB",
    youtube_audio: "YT",
    youtube_video: "YT",
  };

  // Check the known MIME map
  if (map[lowerType]) return map[lowerType];

  // Fallback: check for partial match (for browser inconsistencies)
  for (const key in map) {
    if (lowerType.includes(key)) return map[key];
  }

  // Last resort: extract extension from filename
  const parts = fileName.split(".");
  if (parts.length > 1) return parts.pop().toUpperCase();

  return "OTHER";
};
